<ng-container *ngIf="data.type === 'textinput'">
    <wizard-labeled-field [label]="data.label" [size]="fieldSize">
        <div class="ui icon input">
            <input
                type="text"
                placeholder="{{ data.placeholder }}"
                name="{{ data.payloadKey }}"
                [ngModel]="text"
                (ngModelChange)="updateText($event)"
            />
            <i class="search icon" *ngIf="data.payloadKey === 'query'"></i>
        </div>
    </wizard-labeled-field>
</ng-container>

<ng-container *ngIf="data.type === 'textarea'">
    <!-- NOTE: class 'full-width' is used in labeled-field's host styles -->
    <wizard-labeled-field [label]="data.label" [size]="fieldSize" [class]="classes">
        <wizard-tooltip>
            Enter your Agenda to easily share information with your meeting attendees. Agenda details will be
            automatically added to the meeting invite and calendar event.
            <a href="https://faq.calendarhero.com/hc/en-us/articles/4430373898267-Can-I-add-an-Agenda-to-my-meeting-" target="_blank"
                >Learn More</a
            >
        </wizard-tooltip>
        <div class="ui left icon input">
            <textarea
                rows="5"
                placeholder="{{ data.placeholder }}"
                name="{{ data.payloadKey }}"
                [ngModel]="text"
                (ngModelChange)="updateText($event)"
            ></textarea>
            <i class="bars icon"></i>
        </div>
    </wizard-labeled-field>
</ng-container>
